import React from 'react';
import './Footer.css';
import police_img from './police.png'

const Footer = () => {
  const copyrightYears = "2025-2030"; // As per your image
  const companyName = "微元合成生物技术有限公司 ";
  const icpNumber = "京ICP备2025125843号-1";
  // Standard link for ICP备案查询, you might need to adjust if it's specific
  const icpLink = "https://beian.miit.gov.cn/";

  return (
    <footer className="site-footer">
      <div className="footer-content-wrapper">
        <span className="footer-item">Copyright © {copyrightYears}</span>
        {/* <span className="footer-item">{companyName}</span> */}
        <span className="footer-item">
          网站备案号: <a href={icpLink} target="_blank" rel="noopener noreferrer">{icpNumber}</a>
        </span>
        <div className="single-icon-container">
        <img
            src={police_img}            
            className="police_img"
          />
        </div>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045896" rel="noreferrer" target="_blank">京公网安备11010802045896号</a>
      </div>
    </footer>
  );
};

export default Footer;